var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 36,
    viewBox: "0 0 32 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5 9L16 0L0.5 9V27L16 36L31.5 27V9ZM29.7813 10L16.0035 2L2.22576 10V26L16.0035 34L29.7813 26V10Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0564 11L16.0009 4L3.94531 11V25L16.0009 32L28.0564 25V11ZM16.0127 19.2682C16.8733 19.2682 17.2583 19.2455 17.3329 19.2397L17.3305 19.2389C19.9655 19.1221 21.9314 18.6625 21.9314 18.1138C21.9314 17.5651 19.9651 17.1051 17.3305 16.9875V18.7817C17.2562 18.7892 16.8457 18.823 16.0259 18.823C15.3427 18.823 14.8485 18.7945 14.6756 18.7817V16.9862C12.0352 17.1063 10.0631 17.5655 10.0631 18.1138C10.0631 18.6621 12.0339 19.1233 14.6743 19.2397C14.8447 19.2479 15.3295 19.2682 16.0127 19.2682ZM17.3329 16.801V16.8018L17.3321 16.801C17.3324 16.801 17.3327 16.801 17.3329 16.801ZM17.3329 15.1928V16.801C20.3158 16.9414 22.5569 17.5309 22.5569 18.2392C22.5569 18.9476 20.3133 19.5392 17.3321 19.6762V24.8271H14.6752V19.6782C11.6874 19.5404 9.43969 18.9488 9.43969 18.2396C9.43969 17.5304 11.6869 16.9384 14.6752 16.801V15.1949H10.9988V12.7446H21.0114V15.1928H17.3329Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.a14817d9e118abe40d467e5134d6a291.svg";
export { ForwardRef as ReactComponent };